var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 53,
    viewBox: "0 0 233 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M213.241 8.65087C289.741 -10.2933 353.741 8.64823 338.241 16.6517V95.6547H33.2415C3.57483 69.3203 -27.9585 43.7488 43.2415 54.1512C132.241 67.1542 162.242 21.2802 213.241 8.65087Z",
    fill: "url(#paint0_linear_33617_93529)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33617_93529",
    x1: 166.086,
    y1: -8.5625,
    x2: 166.086,
    y2: 95.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5C7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsRightBg);
export default __webpack_public_path__ + "static/media/events-right-bg.d90e581fa59865196340c85a3a54d8f7.svg";
export { ForwardRef as ReactComponent };